import { IconWhatsApp } from "./Icons";

const WhatsAppFloat = () => (
  <a
    href="https://wa.me/6285178228989"
    target="_blank"
    rel="noopener noreferrer"
    className="wa-float"
    title="Chat on WhatsApp"
  >
    <IconWhatsApp width="30" height="30" />
  </a>
);

export default WhatsAppFloat;
